import { ActionResponseType } from "../../../common/types/common.types";
import { ApiClient } from "../../../core/api/apiClient.service";
import { ReportViewerType } from "../../../components/ReportViewer/ReportViewer.types";

const client = new ApiClient();

export const getAllInspectionReport = async (
  params: ReportViewerType
): Promise<ActionResponseType> => {
  try {
    const URL: string = `Report/GetReport`;
    const config = {
      headers: {
        responseType: "arraybuffer",
      },
    };

    // const config = {
    //   headers: {
    //     "content-type": "multipart/form-data",
    //   },
    // };

    let reportData = {} as ActionResponseType;
    await client
      .post<ActionResponseType>(URL, params, config)
      .then((response: ActionResponseType) => {
        // const decodedData = JSON.parse(
        //   new TextDecoder("utf-8").decode(new Uint8Array(response.Data))
        // );

        reportData = response;
      })
      .catch((error) => {
        reportData = {} as ActionResponseType;
        throw error;
      });
    return reportData;
  } catch (error) {
    throw error;
  }
};

export default getAllInspectionReport;
